import { createGlobalStyle } from 'styled-components'

import {
  MontserratBold,
  NunitoBold,
  NunitoRegular,
  RobotoMonoRegular,
} from './fonts'
import { theme } from './theme'
import { heading, modifySize } from './utils'

export const GlobalStyle = createGlobalStyle`
@font-face {
    font-family: "CustomFont";
    font-weight: normal;
    src: local("CustomFont"), url(${NunitoRegular}) format("truetype");
  }

  @font-face {
    font-family: "CustomFont";
    font-weight: bold;
    src: local("CustomFont"), url(${MontserratBold}) format("truetype");
  }

  @font-face {
    font-family: "CustomBoldFont";
    font-weight: bold;
    src: local("CustomBoldFont"), url(${NunitoBold}) format("truetype");
  }

  @font-face {
    font-family: "Roboto-Mono";
    font-weight: normal;
    src: local("Roboto-Mono"), url(${RobotoMonoRegular}) format("truetype");
  }


  body {
      font-family: "CustomFont", sans-serif;
      font-size: ${modifySize(theme['font-size'], 1.0)};
      background-color: ${theme['theme-color']};
      background-image: ${theme.texture};
      color: ${theme.title};
      margin: ${theme['margin-zero']};
  }

  /* Headings */
  h1 {
    ${heading({ theme }, modifySize(theme['font-size'], 2))}
  }

  h2 {
    ${heading({ theme }, modifySize(theme['font-size'], 1.75))}
  }

  h3 {
    ${heading({ theme }, modifySize(theme['font-size'], 1.5))}
  }

  h4{
    ${heading({ theme }, modifySize(theme['font-size'], 1.25))}
  }
  h1, h2, h3, h4, h5, h6 {
      a {
          text-decoration: none;
          color: inherit;
      }
  }

  a {
      text-decoration: none;
      color: inherit;
  }
  p{
    font-size: ${modifySize(theme['font-size'], 2)};
  }
`
